import {Module} from "vuex";
import {RootStoreState} from "@/store/RootStoreState";

interface MenuState {
    isOpened: boolean,
}

const menuModule: Module<MenuState, RootStoreState> = {
    namespaced: true,
    state: {
        isOpened: false,
    },
    mutations: {
        toggleMenu(state) {
            state.isOpened = !state.isOpened;
        },
        closeMenu(state) {
            state.isOpened = false;
        },
    },
    actions: {
        toggleMenu({commit}) {
            commit('toggleMenu');
        },
        closeMenu({commit}) {
            commit('closeMenu');
        },
    }
};

export default menuModule;
